import { render, staticRenderFns } from "./BaseChip.vue?vue&type=template&id=30c9d7a4&"
import script from "./BaseChip.vue?vue&type=script&lang=ts&"
export * from "./BaseChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports